import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Helmet from "react-helmet-async";

import Icon from "../../../components/Library/Icon";

import styles from "./NotFound.css";

export default function NotFound({ errorText }) {
  return (
    <>
      <Helmet>
        <title>Page not found - Axios</title>
      </Helmet>
      <main id="main" role="main" className={styles.root}>
        <Icon
          name="confused-person"
          description="Confused person image"
          path="img"
          className={styles.icon}
        />
        <p className={styles.description}>{errorText}</p>
        <Link to="/" className={styles.button}>
          Read top stories
        </Link>
      </main>
    </>
  );
}

NotFound.defaultProps = {
  errorText: "404! In other words, something went wrong.",
};

NotFound.propTypes = {
  errorText: PropTypes.string,
};
